module.exports = __webpack_public_path__ + "img/pineapple.715a2049.jpeg";